import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { GalleryService } from '../../services/gallery.service';
import Swal from 'sweetalert2';

import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.css']
})
export class MenuItemComponent implements OnInit, OnDestroy {

  @Input () item;
  @Input () detailUser;
 /*  @Input () verPrecios; */
  @Input () param_code;
  
  image;
  bigImage;
  idModal;

  showHelpTouch = true;
  reloj;

  constructor(
    private _gallery: GalleryService,
    public analytics: AngularFireAnalytics
  ) { }

  async ngOnInit(){

      Swal.fire({
        title: 'Cargando información...',
        text: 'Espere por favor.',
        icon: 'info'
      });

      Swal.showLoading();

      this.image = "../../../assets/images/loading.gif";
      this.bigImage = "../../../assets/images/loading.gif";
      this.idModal = this.item.filename.split('.')[0]; // Solo el nombre del archivo
      this.image = await this._gallery.imageExist(this.item.filename, 'assets/images/platillos/noimage.png');
      if(this.image){
        Swal.close();
      }

      this.reloj = setTimeout(()=>{
        this.showHelpTouch = false;
      },4000);
  }

  ngOnDestroy() {
    clearTimeout(this.reloj);
  }

  showModal(size:string){

    this.analytics.logEvent(this.item.title.replace(/ /g,""));

    const modal = document.getElementById(this.idModal);
    modal.style.display = "block";
    setTimeout(() => { 
      this.bigImage = this.item.sizes.find( obj => obj.size == size)['url'];
      if(!this.bigImage){
        this.bigImage = '../../../assets/images/platillos/noimage.png'
      }
    }, 2000)
  }

  hideModal(modal_id: string){
    var modal = document.getElementById(modal_id);
    modal.style.display = "none";
  }

}